// extracted by mini-css-extract-plugin
module.exports = {"custom_select":"Select_custom_select__3sRBu","custom_select_arrow":"Select_custom_select_arrow__2780v","custom_select_dropdown":"Select_custom_select_dropdown__AHKr5"};